export type UpdateUserMultifactorEnrollmentErrorCode = 'FAILED-ENROLLMENT' | 'UNKNOWN';

export class UpdateUserMultifactorEnrollmentError extends Error {
    code: UpdateUserMultifactorEnrollmentErrorCode;
    constructor(code: UpdateUserMultifactorEnrollmentErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
